import actionTypes from '../constants/action-types';

const settings = (state = {}, action) => {
  if (action.type !== actionTypes.SET_INTEGRATION_SETTINGS) return state;

  const { settings: settingsData } = action.payload;

  return settingsData;
};

export default settings;
